import script from "./RecoveryAbandonedCartEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./RecoveryAbandonedCartEdit.vue?vue&type=script&setup=true&lang=js"

import "./RecoveryAbandonedCartEdit.vue?vue&type=style&index=0&id=101d4c38&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-101d4c38"]])

export default __exports__